import * as Sentry from "@sentry/react";
import { getEnv } from "./utils/runtime-config";

const dsn = getEnv("SENTRY_DSN") || import.meta.env.VITE_SENTRY_DSN || "";
const tracesSampleRateStr = getEnv("SENTRY_TRACES_SAMPLE_RATE");
const tracesSampleRate = tracesSampleRateStr
  ? Number.parseFloat(tracesSampleRateStr)
  : 0.0;
const replaysSessionSampleRateStr = getEnv(
  "SENTRY_REPLAYS_SESSION_SAMPLE_RATE",
);
const replaysSessionSampleRate = replaysSessionSampleRateStr
  ? Number.parseFloat(replaysSessionSampleRateStr)
  : 0.1;
const replaysOnErrorSampleRateStr = getEnv(
  "SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE",
);
const replaysOnErrorSampleRate = replaysOnErrorSampleRateStr
  ? Number.parseFloat(replaysOnErrorSampleRateStr)
  : 1.0;
const backendUrl = getEnv("VITE_BACKEND_URL");

Sentry.init({
  dsn,
  sendDefaultPii: getEnv("SENTRY_SEND_DEFAULT_PII") === "true",
  tracesSampleRate,
  replaysSessionSampleRate,
  replaysOnErrorSampleRate,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracePropagationTargets: ["localhost", backendUrl, /^\/api/].filter(Boolean),
  environment:
    getEnv("SENTRY_ENV") || import.meta.env.VITE_SENTRY_ENV || "development",
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications.",
    "AbortError",
    "canceled",
    "Network Error",
    "AxiosError: Network Error",
    "ERR_NETWORK",
    "ERR_CANCELED",
    "Failed to fetch",
    "Load failed",
  ],
});
